import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor(UsersResource) {
        this.UsersResource = UsersResource;
    }

    $onInit() {
        this.st = new SmartTable();

        var ctrl = this;
        this.displayed = [];
        this.callServer = function callServer(tableState) {
            ctrl.isLoading = true;
            var pagination = tableState.pagination;
            var page = pagination.start / pagination.number;
            var number = pagination.number;
            var searchText = (tableState.search.predicateObject ? tableState.search.predicateObject.searchText : '');
            var sort = tableState.sort.predicate;
            var sortReverse = tableState.sort.reverse;
            if (ctrl.page != page || ctrl.number != number || ctrl.searchText != searchText || ctrl.sort != sort || ctrl.sortReverse != sortReverse) {
                ctrl.page = page;
                ctrl.number = number;
                ctrl.searchText = searchText;
                ctrl.sort = sort;
                ctrl.sortReverse = sortReverse;
                ctrl.UsersResource
                    .getAllRegularCompanyUsersWithPagination(ctrl.companyId, "roles", ctrl.page, ctrl.number, ctrl.searchText, ctrl.sort, ctrl.sortReverse)
                    .then(dto => {
                        pagination.totalItemCount = dto.totalElements;
                        pagination.numberOfPages = dto.totalPages;
                        ctrl.st.displayedItems = dto.content;
                })
                .finally(() => ctrl.isLoading = false);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/administrators-developers/administrators-developers.controller.js